import React from 'react';
import OptionCard from './OptionCard';
import './QuestionCard.scss';

function QuestionCard({ question, onSelect }) {
  return (
    <div className="question-card">
      <h2>{question.question}</h2>
      <div className="question-tip">Select the picture that best describes your style.</div>
      <div className="options">
        {question.options.map((option, index) => (
          <OptionCard
            key={index}
            text={option.text}
            image={option.image}
            onClick={() => onSelect(option.weights)}
          />
        ))}
      </div>
    </div>
  );
}

export default QuestionCard; 